import { Link } from '@uhg-abyss/web/ui/Link';
import { Text } from '@uhg-abyss/web/ui/Text';
import find from 'lodash/find';
import React, { useEffect } from 'react';
import { useMediaQuery } from 'usehooks-ts';

import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { useFeatureFlag } from '../../../../hooks/useFeatureFlag';
import { useLagoon } from '../../../../hooks/useLagoon';
import { adobeLinkTrackEvent } from '../../../AdobeTagging/adobeLinkTrackEvent';
import { adobeSubpageTrackEvent } from '../../../AdobeTagging/adobeSubpageTrackEvent';
import { mobileOnly } from '../../../ConstantsStyles';
import {
  BenefitContainer,
  BenefitsSubHeadingContainer,
} from './BenefitsList.styled';
import { Divider } from './KeywordSearchDropdown.styled';

export const RxBenefitsList = ({ showDivider = true }) => {
  const isMobileView = useMediaQuery(mobileOnly);
  const uiMessaging = useLagoon('ui-messaging')();
  const [enableRxBenefitsAnalytics] = useFeatureFlag([
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_RX_BENEFITS_ANALYTICS,
  ]);
  const rxBenefitsSection = find(uiMessaging, {
    key: ConstantsLagoon.RX_BENEFITS_SECTION.RX_BENEFITS_SECTION,
  });
  const rxBenefitsSectionCtaContent = find(uiMessaging, {
    key: ConstantsLagoon.RX_BENEFITS_SECTION.RX_BENEFITS_SECTION_CTA,
  });

  useEffect(() => {
    if (enableRxBenefitsAnalytics) {
      adobeSubpageTrackEvent({
        contentSection: 'pharmacy and prescription',
      });
    }
  }, [enableRxBenefitsAnalytics]);

  const handleRxBenefitClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!rxBenefitsSectionCtaContent?.url) {
      return;
    }
    if (enableRxBenefitsAnalytics) {
      adobeLinkTrackEvent({
        name: 'go to rx home page',
        location: 'body:search input option list:pharmacy and prescription',
        destinationUrl: rxBenefitsSectionCtaContent.url,
      });
    }
    window.location.assign(rxBenefitsSectionCtaContent.url);
  };
  return (
    <React.Fragment>
      {showDivider && <Divider />}
      <BenefitContainer>
        <Text
          css={{
            'abyss-text-root': {
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: '140%',
              letterSpacing: '0px',
            },
          }}
          data-testid="rx-benefits-section-heading"
        >
          {rxBenefitsSection?.title}
        </Text>
        <BenefitsSubHeadingContainer isMobile={isMobileView}>
          <Text
            css={{
              'abyss-text-root': {
                color: '#323334',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '140%',
                letterSpacing: '0px',
              },
            }}
          >
            {rxBenefitsSection?.message}
          </Text>
          <Text
            css={{
              'abyss-text-root': {
                fontSize: '16px',
                fontStyle: 'normal',
                lineHeight: '140%',
                fontWeight: 400,
                letterSpacing: '0px',
              },
            }}
          >
            <Link
              css={{
                textDecorationLine: 'underline',
                textDecorationStyle: 'solid',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: '140%',
                fontSize: '16px',
              }}
              data-testid="rx-benefit-link"
              hideIcon
              href={rxBenefitsSectionCtaContent?.url || '#'}
              onClick={handleRxBenefitClick}
            >
              {rxBenefitsSectionCtaContent?.title}
            </Link>{' '}
            {rxBenefitsSectionCtaContent?.message}
          </Text>
        </BenefitsSubHeadingContainer>
      </BenefitContainer>
    </React.Fragment>
  );
};
